import styles from './MockKycPage.module.scss';
import type { UserKycSession } from '../../types/kyc';

export interface MockKycPageProps {
  session: UserKycSession;
}

function MockKycPage({ session }: MockKycPageProps) {
  const safeMockKycUrl = session.token;

  return (
    <div className={styles.root}>
      {safeMockKycUrl && (
        <div className={styles.iframeContainer}>
          <iframe
            src={safeMockKycUrl}
            title="Mock KYC Verification"
            className={styles.iframe}
          />
        </div>
      )}
    </div>
  );
}

export default MockKycPage;
